/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2020-12-12 14:15:25
 * @LastEditors: qiuwenjing
 * @LastEditTime: 2021-08-23 10:36:14
 */


import { Module } from 'vuex'
import keymirror from '../../utils/keymirror'
import state, { AreaList,AreaState } from './state'
import { Post, Get, Patch, Put, Delete, ax } from '../../../http/http'
import * as actionPayload from './action'
import qs from 'qs'

import {
    namespace
} from 'vuex-class'

import { getter, mutation, action, decorator } from '../../utils/vuexUtil'

let getters = getter(state, {
})

let mutations = mutation(state, {
})

let actions = action(state, {
     /**
     * 获取省
     */
    async  getArea ({ commit }, payload: void){
        let list = await Get<Types.ListResponse<AreaList>>(
            `api/TbRegion/GetTbRegionListProvince`,{}
        )
        return list
    },
      /**
     * 获取市
     */
    async  getCity ({ commit }, payload: actionPayload.AreaItem){
        let list = await Get<Types.ListResponse<AreaList>>(
            `api/TbRegion/GetTbRegionListCity`,payload
        )
        return list
    },
      /**
     * 获取区
     */
    async  getCounty ({ commit }, payload: actionPayload.CityItem){
        let list = await Get<Types.ListResponse<AreaList>>(
            `api/TbRegion/GetTbRegionListArea`,payload
        )
        return list
    }

})

let store: Module<AreaState, Types.State.RootState> = {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}

export let types = {
    state: keymirror(state),
    getter: keymirror(getters),
    mutation: keymirror(mutations),
    action: keymirror(actions)
}

const storeName = 'area'
let space = namespace(storeName)
export let State = decorator(space.State, types.state)
export let Getter = decorator(space.Getter, types.getter)
export let Mutation = decorator(space.Mutation, types.mutation)
export let Action = decorator(space.Action, types.action)

export * from './action'
export * from './state'

export default store


// WEBPACK FOOTER //
// ./src/vuex/modules/area/index.ts